// extracted by mini-css-extract-plugin
module.exports = {"active":"DiscountStatusField_active__2Ri08","inactive":"DiscountStatusField_inactive___ILRq"};